import Messages from "./components/Messages";
import Channels from "./components/Channels";
import UserInfo from "./components/UserInfo";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";

import MesssagesCounter from "../../components/MessagesCounter";

import { mapGetters, mapState } from "vuex";

import { required, minValue } from "vuelidate/lib/validators";

import {
  PLACES_SUGGESTIONS,
  CREATE_DEAL,
  CREATE_USER_REPORT
} from "./gql/MessagesQueries";

import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import CloseIcon from "@/assets/images/icons/close.svg?inline";
import LocationIcon from "@/assets/images/icons/report_place.svg?inline";
import CalendarIcon from "@/assets/images/icons/report_calendar.svg?inline";
import PriceIcon from "@/assets/images/icons/report_price.svg?inline";

export default {
  name: "messages",

  data() {
    return {
      loadingChats: false,
      messages: [],
      token: "",
      channels: [],
      active_channel: null,
      chatChannel: null,
      currentChatUsers: [],
      isInitChannel: false,
      hasMoreMessages: false,
      chatPaginator: {},
      refuseMessage: "",

      reportDeal: {
        location: "",
        date: new Date(),
        price: ""
      },
      skiplocationsQuery: true,
      isLocationsLoading: false,
      submitReportDealLoading: false,

      submitRefuseLoading: false,

      mobileActivetedMessages: null,
      mobileActivetedUserInfo: null
    };
  },

  validations: {
    reportDeal: {
      location: {
        required
      },
      date: {
        required
      },
      price: {
        required,
        minValue: minValue(0)
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    ...mapState(["isInitTwilio"]),

    filteredLocationOptions() {
      const filtered = [];

      if (!this.places) {
        return [];
      }

      this.places.forEach(r => {
        filtered.push({
          type: r.type,
          places: r.places,
          limit: 8,
          onSelected: selected => {
            this.selected = selected.item;
          }
        });
      });

      return Object.freeze(filtered);
    },

    isMobile() {
      return this.$mq === "md" || this.$mq === "sm" || this.$mq === "xs";
    }
  },

  apollo: {
    places: {
      query: PLACES_SUGGESTIONS,
      fetchPolicy: "no-cache",
      variables() {
        return {
          address: this.locationRequestQuery
        };
      },

      skip() {
        return this.skiplocationsQuery;
      },

      result() {
        this.skiplocationsQuery = true;

        this.isLocationsLoading = false;
      }
    }
  },

  mounted: function() {
    if (this.isInitTwilio != null) {
      this.initializeChatChannels();
    }

    window.Intercom("update", {
      hide_default_launcher: true
    });
  },

  methods: {
    initializeChatChannels() {
      this.$twilioClient.client
        .getUserChannelDescriptors()
        .then(channels => {
          this.channels = channels.state.items;

          // Init first channel
          if (channels.state.items.length == 1) {
            this.showMessages(channels.state.items[0]);
          }

          this.loadingChats = true;
        })
        .catch(error => {
          this.$toasted.error(error);
          window.location.reload(true);
        });
    },

    setupChannel(channel) {
      if (this.chatChannel) {
        this.currentChatUsers = [];
        this.messages = [];

        this.chatChannel.removeListener(
          "messageAdded",
          this.listenerAddedMessage
        );
      }

      this.chatChannel = channel;
      this.isInitChannel = true;

      // Channel is blocked
      if (this.chatChannel.attributes.blocked) {
        this.isInitChannel = false;
      }

      this.chatChannel.getMessages(50).then(messages => {
        this.chatPaginator = messages;

        this.messages = messages.items;
        this.hasMoreMessages = messages.hasPrevPage;

        // for mobile and tablet
        if (this.isMobile) {
          this.mobileActivetedMessages = "show";
        }

        //Update unreaded message for current channel counter
        let someMessageIndex = null;
        if (messages.items.length > 0) {
          someMessageIndex = messages.items[messages.items.length - 1].index;
          this.chatChannel.updateLastConsumedMessageIndex(someMessageIndex);
        }
      });

      this.chatChannel.getMembers().then(currentMembers => {
        currentMembers.forEach(channelMember => {
          channelMember.getUser().then(twilioUser => {
            this.currentChatUsers.push(twilioUser.attributes);
          });
        });
      });

      this.chatChannel.on("messageAdded", this.listenerAddedMessage);
    },

    listenerAddedMessage(message) {
      this.messages.push(message);
    },

    handleLoadMoreMessasges() {
      this.chatPaginator.prevPage().then(newPaginator => {
        this.chatPaginator = newPaginator;
        this.messages = newPaginator.items.concat(this.messages);
        this.hasMoreMessages = newPaginator.hasPrevPage;
      });
    },

    addMessage(message) {
      if (this.chatChannel) {
        this.chatChannel.sendMessage(message);
      }
    },

    handleDeleteMessage(deletedMsgSid) {
      let msgIndex = this.messages.findIndex(m => {
        return m.sid === deletedMsgSid;
      });

      this.messages.splice(msgIndex, 1);
    },

    handleOpenOponentInfoMobile() {
      // for mobile and tablet
      if (this.isMobile) {
        this.mobileActivetedUserInfo = "show";
      }
    },

    handleBackToChannelsList() {
      if (this.isMobile) {
        this.mobileActivetedUserInfo = "";
        this.mobileActivetedMessages = "";
      }
    },

    showMessages(channel) {
      this.$twilioClient.client.getChannelBySid(channel.sid).then(channel => {
        this.setupChannel(channel);
      });
    },

    handleShowRefuseModal() {
      this.showRefuseModal();
    },

    showRefuseModal() {
      this.$refs.refuseModal.show();
    },

    hideRefuseModal() {
      this.refuseMessage = "";
      this.$refs.refuseModal.hide();
    },

    sendRefuse() {
      this.submitRefuseLoading = false;

      if (this.refuseMessage.length == 0) {
        this.$refs.refuseMessage.$el.focus();
        return false;
      }

      this.$apollo
        .mutate({
          mutation: CREATE_USER_REPORT,
          variables: {
            channelSid: this.chatChannel.sid,
            text: this.refuseMessage
          }
        })
        .then(({ data }) => {
          this.$toasted.success(
            "Thanks for your feedback ! Your report is sent to Pretiis Admin"
          );

          this.hideRefuseModal();
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;
          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitRefuseLoading = false;
        });
    },

    handleShowReportModal() {
      this.showReportModal();
    },

    showReportModal() {
      this.$refs.reportDealModal.show();
    },

    hideReportModal() {
      this.$refs.reportDealModal.hide();
    },

    cleanReportDealData() {
      this.reportDeal.location = "";
      this.reportDeal.price = "";
      this.reportDeal.date = new Date();
    },

    asyncFindLocations(query) {
      if (query.length > 2) {
        this.locationRequestQuery = query;

        this.skiplocationsQuery = false;

        this.isLocationsLoading = true;
      }
    },

    reportDealDateFormatter(date) {
      return this.$moment(date).format("MMM D, YYYY");
    },

    submitReportDeal() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitReportDealLoading = true;

        this.$apollo
          .mutate({
            mutation: CREATE_DEAL,
            variables: {
              channelSid: this.chatChannel.sid,
              location: this.reportDeal.location.description,
              date: this.$moment(this.reportDeal.date).format("YYYY-MM-DD"),
              price: parseInt(this.reportDeal.price)
            }
          })
          .then(({ data }) => {
            this.$toasted.success(
              "Congratulations ! Your newly created deal was sent to Pretiis Admin for confirmation."
            );

            this.hideReportModal();
          })
          .catch(mutationError => {
            const errors = mutationError.graphQLErrors;
            for (let error in errors) {
              this.$toasted.error(errors[error].message);
            }
          })
          .finally(() => {
            this.submitReportDealLoading = false;
          });
      }
    }
  },

  watch: {
    isInitTwilio: function(newData) {
      if (newData != null) {
        this.initializeChatChannels();
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    window.Intercom("update", {
      hide_default_launcher: false
    });
    next();
  },

  components: {
    Messages,
    Channels,
    UserInfo,
    LoadingIcon,
    LocationIcon,
    CalendarIcon,
    PriceIcon,
    CloseIcon,
    Multiselect,
    Datepicker,
    MesssagesCounter
  }
};
